"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default((theme) => {
    var _a;
    return ({
        root: {
            backgroundColor: 'inherit',
            // paddingBottom: 5,
            boxShadow: 'none',
            /** to disable moving down while expanding */
            margin: '0 0 5px 0!important',
            '&::before': {
                opacity: 0,
            },
        },
        fullHeight: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        sumaryFullHeight: {
            flex: '0 0 auto',
        },
        summaryRoot: {
            minHeight: '32px !important',
            height: 32,
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
            borderRadius: (_a = theme.eas) === null || _a === void 0 ? void 0 : _a.radius,
        },
        summaryContent: {
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        summaryRootWithBorder: {
            border: '1px solid #cdcdcd',
        },
        summaryFixed: {
            cursor: 'default !important',
        },
        detailsRoot: {
            padding: 0,
            borderBottomColor: '#cdcdcd',
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
        },
        detailRootWithSideBorder: {
            borderLeftColor: '#cdcdcd',
            borderLeftWidth: 1,
            borderLeftStyle: 'solid',
            borderRightColor: '#cdcdcd',
            borderRightWidth: 1,
            borderRightStyle: 'solid',
        },
        labelRoot: {
            fontWeight: 700,
            marginRight: 5,
        },
        formPanelSummary: {
            fontWeight: 700,
            fontSize: 14,
            lineHeight: '32px',
        },
    });
});
//# sourceMappingURL=panel-styles.js.map